// extracted by mini-css-extract-plugin
export default {"button":"CartButton_button__1I5L7","badge":"CartButton_badge__oet8Q"};